export const CONVERTER_TYPE = {
    PAGE: "page",
    AFILE: "afile"
}